import React , {Component} from 'react';

import PropTypes from 'prop-types';

import PolicyCardSty from './PolicyCard.module.css';


class PolicyCard extends Component{

    constructor(props){
        super(props);
    }

    render(){

        let listLis=this.props.rightListData.map(({id,title})=>{
            return(
                <li>
                    <a onClick={()=>{this.props.onItemClick(id)}}>{title}</a>
                </li>
            );
        });
        
        return(
            <div className={`${PolicyCardSty.pc_Div} ${this.props.className}`}>
                <div className={PolicyCardSty.titleDiv}>
                    <div className={PolicyCardSty.titleSty}>{this.props.title}</div>
                    <div className={PolicyCardSty.moreSty}><a onClick={this.props.onMoreClick}>更多&gt;&gt;</a></div>
                </div>

                <div className={PolicyCardSty.conDiv}>
                    <div className={PolicyCardSty.imgSty} style={{backgroundImage:`url(${this.props.leftImg})`}}></div>
                    <ul>
                        {listLis}
                    </ul>
                </div>
            </div>
        );
    }
}

// 组件属性声明
PolicyCard.propTypes={
    title:PropTypes.string.isRequired,
    leftImg:PropTypes.string.isRequired,
    rightListData:PropTypes.array.isRequired,
    onItemClick:PropTypes.func.isRequired,
    onMoreClick:PropTypes.func.isRequired,
}

export default PolicyCard;